import axiosInstance from '../axios/axiosInstance';

export const fetchDueFollowUps = async (page = 1, pageSize = 15) => {
    const response = await axiosInstance.get('/patient-follow-ups/due', {
        params: { page, size: pageSize },
    });
    return response.data;
};

export const submitFollowUpAttempt = async (followUpId, { status, description }) => {
    const payload = { status };
    if (description?.trim()) {
        payload.description = description.trim();
    }
    return axiosInstance.post(`/patient-follow-ups/${followUpId}/attempts`, payload);
};
